import PartnerProfile from "./PartnerProfile";
import PriceUtil from "../../price/PriceUtil";
import { PlanKey } from "./PlanKey";
import TimeUtil from "../../utils/TimeUtil";
import { isBefore } from "date-fns";
import User from "../User";

export default class PartnerUtil {
  static getFullAddress(data: PartnerProfile): string {
    if (!data) return "";

    const {
      street,
      houseNumber,
      postCode,
      district,
      cityDescription,
      neighbourhood,
    } = data;

    const streetText = street
      ? `ul. ${street.trim()}${houseNumber ? ` ${houseNumber.trim()}` : ""}`
      : "";
    const cityText = cityDescription
      ? `${streetText ? ", " : ""}${cityDescription.trim()}`
      : "";
    const neighbourhoodText = neighbourhood ? `, ${neighbourhood.trim()}` : "";
    const districtText = district ? `, ${district.trim()}` : "";
    const postCodeText = postCode ? `, ${postCode.trim()}` : "";

    return `${streetText}${cityText}${neighbourhoodText}${districtText}${postCodeText}`;
  }

  static getPriceFrom(data: PartnerProfile): number {
    let lowestPrice = 0;

    data?.services?.forEach((service) => {
      if (lowestPrice === 0 || lowestPrice > service.price) {
        lowestPrice = service.price;
      }
    });

    return lowestPrice;
  }

  static getPriceFromText(data: PartnerProfile): string {
    const lowestPrice = PartnerUtil.getPriceFrom(data);
    const price = PriceUtil.convertNumberToString(lowestPrice);

    return price ? `${price} ${data.currency || ""}` : "";
  }

  static hasPlan(plan: PlanKey = "0") {
    return plan === "1" || plan === "2";
  }

  static hasFreePeriod(now: Date, user: User | null) {
    const plan = user?.plan;
    const expiresAt = user?.expiresAt;
    if (plan === "2") {
      return true;
    }
    if (plan === "0" && !!expiresAt) {
      const expiryDate = TimeUtil.convertDateStringToDate(expiresAt);

      if (!expiryDate) {
        return false;
      }

      const isFreePeriodExpired = TimeUtil.isAfter(now, expiryDate);
      return !isFreePeriodExpired;
    }
    return false;
  }

  static hasFreePeriodBefore(user: User | null) {
    return !!user?.plan?.length && !!user?.expiresAt?.length;
  }

  static isPaid(user: User | null) {
    if (user?.accountType === "client") {
      return true;
    }
    const plan = user?.plan;
    const expiresAt = user?.expiresAt;
    if (plan === "0" || !expiresAt) {
      return false;
    }
    const hasExpiresAt = TimeUtil.createExpiresAt(expiresAt);
    const hasPlan = PartnerUtil.hasPlan(plan);

    const now = new Date();

    const isSameDay = expiresAt === TimeUtil.convertDateToDateString(now);
    const isNotExpired =
      hasExpiresAt && (isBefore(now, hasExpiresAt) || isSameDay);
    return hasPlan && !!isNotExpired;
  }
}
